import React from 'react';

import DeveloperModeIcon from '@material-ui/icons/DeveloperMode';

import {
  PERMISSAO_TELA_LOGS_RELATORIOS_LISTAR,
  PERMISSAO_TELA_DADOS_FISCAIS_CHECKOUT_LISTAR,
  PERMISSAO_TELA_COMPUTADORES_AUTORIZADOS_LISTAR,
} from '../../../utils/dadosTelas';
import SubMenu from '../SubMenu';

const SubMenuDesenvolvedor = ({
  classes,
  open,
  onMenuClick,
  isOpen,
  handleToggle,
  hasResource,
  permissoes,
}) => (
  <SubMenu
    handleToggle={handleToggle}
    isOpen={isOpen}
    sidebarIsOpen={open}
    name="Desenvolvedor"
    icon={<DeveloperModeIcon className={classes.icon} />}
  >
    {permissoes[PERMISSAO_TELA_LOGS_RELATORIOS_LISTAR] &&
      hasResource('logs-task')}
    {permissoes[PERMISSAO_TELA_DADOS_FISCAIS_CHECKOUT_LISTAR] &&
      hasResource('caixas_fc_dados_fiscais')}
    {permissoes[PERMISSAO_TELA_COMPUTADORES_AUTORIZADOS_LISTAR] &&
      hasResource('pdv-machines')}
  </SubMenu>
);

export default SubMenuDesenvolvedor;
